import React, { useState, useEffect, useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line, AreaChart, Area } from 'recharts';
import { Calendar, Clock, MapPin, Phone, Users, Package, DollarSign, FileText, TrendingUp, Settings, Eye, Plus, Minus, Truck, CheckCircle, AlertCircle, User, Lock, LogOut, Home, BarChart3, ClipboardList, Building, Cog, Share2, Wallet, Filter, Edit3, Trash2, RefreshCw, TrendingDown, Activity, CreditCard, Smartphone, Banknote, CalendarDays } from 'lucide-react';

const App = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [pinInput, setPinInput] = useState('');
  const [showAddSupplier, setShowAddSupplier] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [showEditTotalBags, setShowEditTotalBags] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('semana');
  // Estados para edición
  const [editingIncome, setEditingIncome] = useState(null);
  const [editingExpense, setEditingExpense] = useState(null);
  const [editingDelivery, setEditingDelivery] = useState(null);
  const [editingVisit, setEditingVisit] = useState(null);
  const [editingGanttTask, setEditingGanttTask] = useState(null);
  const [showAddSupplierPayment, setShowAddSupplierPayment] = useState(false);
  const [editingSupplierPayment, setEditingSupplierPayment] = useState(null);

  // === Datos simulados (IGUAL que tu archivo original) ===
  const [totalBags, setTotalBags] = useState(500000);
  const [assignedBags, setAssignedBags] = useState(400000);
  const [suppliers, setSuppliers] = useState([
    { id: 1, name: 'Centro Comercial Gráfica Shen', type: 'troquelado', contact: 'Juan Carlos', phone: '993 801 851', capacity: 20000, location: 'CC Gráfica Shen', stand: 'Stand 123', address: 'Av. Industrial 123', ratePerThousand: 25, paymentMethods: ['yape', 'transferencia'] },
    { id: 2, name: 'Galería Expreso', type: 'troquelado', contact: 'William', phone: '993 801 851', capacity: 7000, location: 'Galería Expreso', stand: 'Stand 45', address: 'Jr. Comercial 456', ratePerThousand: 25, paymentMethods: ['efectivo', 'plin'] },
    { id: 3, name: 'Huancabelica 1095', type: 'troquelado', contact: 'Hector', phone: '961 421 638', capacity: 15000, location: 'Huancabelica 1095', stand: 'Local 1095', address: 'Huancabelica 1095', ratePerThousand: 25, paymentMethods: ['transferencia', 'yape'] },
    { id: 4, name: 'Centro Comercial Gráfica Shen', type: 'pegado', contact: 'Pilar', phone: '916 804 352', capacity: 5000, location: 'CC Gráfica Shen', stand: 'Stand 124', address: 'Av. Industrial 123', ratePerThousand: 50, paymentMethods: ['yape', 'efectivo'] },
    { id: 5, name: 'Miriam', type: 'pegado', contact: 'Miriam', phone: '957 313 639', capacity: 1500, location: 'Taller Miriam', stand: 'Taller', address: 'Calle Artesanal 789', ratePerThousand: 50, paymentMethods: ['plin', 'transferencia'] },
    { id: 6, name: 'Cecilia', type: 'pegado', contact: 'Cecilia', phone: '921 424 227', capacity: 4000, location: 'Taller Cecilia', stand: 'Taller', address: 'Av. Manualidades 321', ratePerThousand: 50, paymentMethods: ['efectivo', 'yape'] },
    { id: 7, name: 'Mario', type: 'pegado', contact: 'Mario', phone: '916 724 814', capacity: 2000, location: 'Taller Mario', stand: 'Taller', address: 'Jr. Productores 654', ratePerThousand: 50, paymentMethods: ['transferencia', 'plin'] }
  ]);
  const [visits, setVisits] = useState([
    { id: 1, supplierId: 1, type: 'troquelado', quantity: 25000, supervisor: 'Carlos Mendoza', notes: 'Primer lote completado', timestamp: '2023-10-02T09:30:00', stage: 'troquelado' },
    { id: 2, supplierId: 1, type: 'troquelado', quantity: 30000, supervisor: 'Carlos Mendoza', notes: 'Segundo lote en proceso', timestamp: '2023-10-03T10:15:00', stage: 'troquelado' },
    { id: 3, supplierId: 4, type: 'pegado', quantity: 15000, supervisor: 'Ana Rodríguez', notes: 'Inicio de pegado de asas', timestamp: '2023-10-06T14:20:00', stage: 'pegado' },
    { id: 4, supplierId: 2, type: 'troquelado', quantity: 20000, supervisor: 'Carlos Mendoza', notes: 'Troquelado en curso', timestamp: '2023-10-04T11:45:00', stage: 'troquelado' },
    { id: 5, supplierId: 5, type: 'pegado', quantity: 10000, supervisor: 'Ana Rodríguez', notes: 'Pegado avanzado', timestamp: '2023-10-07T16:30:00', stage: 'pegado' }
  ]);
  const [deliveries, setDeliveries] = useState([
    { id: 1, type: 'pacpac_to_epack', from: 'PacPac', to: 'Epack', bags: 400000, handles: 50000, deliveredBy: 'Logística PacPac', receivedBy: 'Carlos Mendoza', notes: 'Entrega inicial de material base', timestamp: '2023-10-01T08:00:00', stage: 'material_base' },
    { id: 2, type: 'epack_to_supplier', from: 'Epack', to: 'Juan Carlos', supplierId: 1, bags: 55000, handles: 0, deliveredBy: 'Logística Epack', receivedBy: 'Juan Carlos', notes: 'Asignación para troquelado', timestamp: '2023-10-01T10:00:00', stage: 'troquelado_asignado' },
    { id: 3, type: 'supplier_to_supplier', from: 'Juan Carlos', to: 'Pilar', supplierFromId: 1, supplierToId: 4, bags: 55000, handles: 0, deliveredBy: 'Juan Carlos', receivedBy: 'Pilar', notes: 'Transferencia de troquelado a pegado', timestamp: '2023-10-05T15:00:00', stage: 'pegado_asignado' },
    { id: 4, type: 'supplier_to_pacpac', from: 'Pilar', to: 'PacPac', supplierId: 4, bags: 15000, handles: 0, deliveredBy: 'Pilar', receivedBy: 'Logística PacPac', notes: 'Entrega final completada', timestamp: '2023-10-08T16:00:00', stage: 'entrega_final' }
  ]);
  const [expenses, setExpenses] = useState([
    { id: 1, amount: 150.50, concept: 'Transporte a proveedores', category: 'transporte', timestamp: '2023-10-02T10:00:00', paymentMethod: 'efectivo' },
    { id: 2, amount: 85.20, concept: 'Materiales adicionales', category: 'materiales', timestamp: '2023-10-04T14:30:00', paymentMethod: 'yape' },
    { id: 3, amount: 200.00, concept: 'Combustible', category: 'transporte', timestamp: '2023-10-05T09:15:00', paymentMethod: 'plin' },
    { id: 4, amount: 120.75, concept: 'Almuerzos supervisión', category: 'otros', timestamp: '2023-10-06T13:00:00', paymentMethod: 'efectivo' }
  ]);
  const [incomes, setIncomes] = useState([
    { id: 1, amount: 15000.00, concept: 'Adelanto PacPac', type: 'adelanto', timestamp: '2023-09-25T09:00:00', paymentMethod: 'transferencia' },
    { id: 2, amount: 8000.00, concept: 'Pago parcial', type: 'pago', timestamp: '2023-10-03T11:30:00', paymentMethod: 'yape' }
  ]);
  const [supplierPayments, setSupplierPayments] = useState([
    { id: 1, supplierId: 1, amount: 1375.00, concept: 'Pago troquelado 55,000 bolsas', paymentMethod: 'yape', timestamp: '2023-10-05T14:00:00', status: 'pagado' },
    { id: 2, supplierId: 4, amount: 750.00, concept: 'Pago pegado 15,000 bolsas', paymentMethod: 'efectivo', timestamp: '2023-10-08T15:00:00', status: 'pagado' }
  ]);
  const [supplies, setSupplies] = useState([
    { id: 1, name: 'Goma industrial', quantity: 50, unit: 'kg', cost: 1200.00, supplier: 'Distribuidora Química', timestamp: '2023-09-28T11:00:00' },
    { id: 2, name: 'Troqueles personalizados', quantity: 5, unit: 'unidades', cost: 850.00, supplier: 'Metalurgia Andina', timestamp: '2023-09-30T13:00:00' }
  ]);
  const [ventaTroquelado, setVentaTroquelado] = useState(35);
  const [ventaPegado, setVentaPegado] = useState(65);
  const [costoTroqueladoProveedores, setCostoTroqueladoProveedores] = useState({ 1: 25, 2: 25, 3: 25 });
  const [costoPegadoProveedores, setCostoPegadoProveedores] = useState({ 4: 50, 5: 50, 6: 50, 7: 50 });
  const [sharedSessionToken, setSharedSessionToken] = useState('pacpac_live_12345');

  // === Cálculos (IGUAL que tu archivo) ===
  const troqueladoProgress = visits.filter(v => v.type === 'troquelado').reduce((sum, v) => sum + v.quantity, 0);
  const pegadoProgress = visits.filter(v => v.type === 'pegado').reduce((sum, v) => sum + v.quantity, 0);
  const totalProgress = Math.min(troqueladoProgress, pegadoProgress);
  const dailyProgress = useMemo(() => {
    const today = new Date().toISOString().split('T')[0];
    return visits.filter(v => v.timestamp.startsWith(today)).reduce((sum, v) => sum + v.quantity, 0);
  }, [visits]);

  const totalIncomes = incomes.reduce((sum, inc) => sum + inc.amount, 0);
  const totalExpenses = expenses.reduce((sum, exp) => sum + exp.amount, 0);
  const cashBalance = totalIncomes - totalExpenses;

  const calcularCostosTotales = () => {
    let costoTroquelado = 0, costoPegado = 0;
    visits.filter(v => v.type === 'troquelado').forEach(v => {
      const s = suppliers.find(s => s.id === v.supplierId);
      if (s) costoTroquelado += (v.quantity / 1000) * (costoTroqueladoProveedores[s.id] || s.ratePerThousand);
    });
    visits.filter(v => v.type === 'pegado').forEach(v => {
      const s = suppliers.find(s => s.id === v.supplierId);
      if (s) costoPegado += (v.quantity / 1000) * (costoPegadoProveedores[s.id] || s.ratePerThousand);
    });
    return { costoTroquelado, costoPegado, costoTotal: costoTroquelado + costoPegado };
  };
  const calcularIngresosTotales = () => {
    const ingresoTroquelado = (assignedBags / 1000) * ventaTroquelado;
    const ingresoPegado = (assignedBags / 1000) * ventaPegado;
    return { ingresoTroquelado, ingresoPegado, ingresoTotal: ingresoTroquelado + ingresoPegado };
  };
  const { costoTotal } = calcularCostosTotales();
  const { ingresoTotal } = calcularIngresosTotales();
  const utilidadProyectada = ingresoTotal - costoTotal - totalExpenses;

  const proveedorProductividad = useMemo(() => {
    return suppliers.map(s => {
      const avances = visits.filter(v => v.supplierId === s.id);
      const total = avances.reduce((sum, v) => sum + v.quantity, 0);
      const dias = new Set(avances.map(v => v.timestamp.split('T')[0])).size;
      return { ...s, totalAvanzado: total, diasTrabajados: dias, productividadDiaria: dias > 0 ? Math.round(total / dias) : 0 };
    }).sort((a, b) => b.productividadDiaria - a.productividadDiaria);
  }, [suppliers, visits]);

  const ganttTasks = useMemo(() => {
    const materialBase = deliveries.find(d => d.stage === 'material_base');
    const materialBaseProgress = materialBase ? 100 : 0;
    const troqueladoTasks = suppliers.filter(s => s.type === 'troquelado').map(s => {
      const asignacion = deliveries.find(d => d.supplierId === s.id && d.stage === 'troquelado_asignado');
      const avances = visits.filter(v => v.supplierId === s.id && v.type === 'troquelado');
      const totalAvanzado = avances.reduce((sum, v) => sum + v.quantity, 0);
      const progreso = asignacion ? Math.min((totalAvanzado / asignacion.bags) * 100, 100) : 0;
      return { id: `troquelado_${s.id}`, name: `Troquelado - ${s.name}`, progress: progreso, custom_class: 'troquelado' };
    });
    const pegadoTasks = suppliers.filter(s => s.type === 'pegado').map(s => {
      const asignacion = deliveries.find(d => d.supplierId === s.id && d.stage === 'pegado_asignado');
      const avances = visits.filter(v => v.supplierId === s.id && v.type === 'pegado');
      const totalAvanzado = avances.reduce((sum, v) => sum + v.quantity, 0);
      const progreso = asignacion ? Math.min((totalAvanzado / asignacion.bags) * 100, 100) : 0;
      return { id: `pegado_${s.id}`, name: `Pegado - ${s.name}`, progress: progreso, custom_class: 'pegado' };
    });
    const entregaFinalBags = deliveries.filter(d => d.stage === 'entrega_final').reduce((sum, d) => sum + d.bags, 0);
    const entregaFinalProgress = (entregaFinalBags / assignedBags) * 100;
    return [
      { id: 'material_base', name: 'Material Base', progress: materialBaseProgress, custom_class: 'material-base' },
      ...troqueladoTasks,
      ...pegadoTasks,
      { id: 'entrega_final', name: 'Entrega Final', progress: entregaFinalProgress, custom_class: 'entrega-final' }
    ];
  }, [deliveries, visits, assignedBags, suppliers]);

  const financialData = useMemo(() => {
    const data = [];
    const today = new Date();
    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      const dateString = date.toISOString().split('T')[0];
      const dayName = date.toLocaleDateString('es-ES', { weekday: 'short' });
      const dayIncomes = incomes.filter(inc => inc.timestamp.startsWith(dateString));
      const dayExpenses = expenses.filter(exp => exp.timestamp.startsWith(dateString));
      data.push({
        name: dayName,
        ingresos: dayIncomes.reduce((sum, inc) => sum + inc.amount, 0),
        gastos: dayExpenses.reduce((sum, exp) => sum + exp.amount, 0)
      });
    }
    return data;
  }, [incomes, expenses]);

  // === Funciones de manejo (IGUAL que tu archivo) ===
  const logout = () => {
    setIsLoggedIn(false);
    setPinInput('');
  };

  const handleLogin = () => {
    if (pinInput === '123qwe') {
      setIsLoggedIn(true);
    } else {
      alert('PIN incorrecto. Intente con: 123qwe');
    }
  };

  const addVisit = (visitData) => {
    setVisits([...visits, { ...visitData, id: Date.now(), timestamp: new Date().toISOString() }]);
  };
  const updateVisit = (updatedVisit) => {
    setVisits(visits.map(v => v.id === updatedVisit.id ? updatedVisit : v));
    setEditingVisit(null);
  };
  const deleteVisit = (id) => {
    if (window.confirm('¿Está seguro de eliminar este avance?')) {
      setVisits(visits.filter(v => v.id !== id));
    }
  };
  const addDelivery = (deliveryData) => {
    setDeliveries([...deliveries, { ...deliveryData, id: Date.now(), timestamp: new Date().toISOString() }]);
  };
  const updateDelivery = (updatedDelivery) => {
    setDeliveries(deliveries.map(d => d.id === updatedDelivery.id ? updatedDelivery : d));
    setEditingDelivery(null);
  };
  const deleteDelivery = (id) => {
    if (window.confirm('¿Está seguro de eliminar este registro de entrega?')) {
      setDeliveries(deliveries.filter(d => d.id !== id));
    }
  };
  const addIncome = (incomeData) => {
    setIncomes([...incomes, { ...incomeData, id: Date.now(), timestamp: new Date().toISOString() }]);
  };
  const updateIncome = (updatedIncome) => {
    setIncomes(incomes.map(i => i.id === updatedIncome.id ? updatedIncome : i));
    setEditingIncome(null);
  };
  const deleteIncome = (id) => {
    if (window.confirm('¿Está seguro de eliminar este ingreso?')) {
      setIncomes(incomes.filter(i => i.id !== id));
    }
  };
  const addExpense = (expenseData) => {
    setExpenses([...expenses, { ...expenseData, id: Date.now(), timestamp: new Date().toISOString() }]);
  };
  const updateExpense = (updatedExpense) => {
    setExpenses(expenses.map(e => e.id === updatedExpense.id ? updatedExpense : e));
    setEditingExpense(null);
  };
  const deleteExpense = (id) => {
    if (window.confirm('¿Está seguro de eliminar este gasto?')) {
      setExpenses(expenses.filter(e => e.id !== id));
    }
  };
  const addSupplierPayment = (paymentData) => {
    setSupplierPayments([...supplierPayments, { ...paymentData, id: Date.now(), timestamp: new Date().toISOString() }]);
    setShowAddSupplierPayment(false);
  };
  const updateSupplierPayment = (updatedPayment) => {
    setSupplierPayments(supplierPayments.map(p => p.id === updatedPayment.id ? updatedPayment : p));
    setEditingSupplierPayment(null);
  };
  const deleteSupplierPayment = (id) => {
    if (window.confirm('¿Está seguro de eliminar este pago a proveedor?')) {
      setSupplierPayments(supplierPayments.filter(p => p.id !== id));
    }
  };
  const addSupplier = (supplierData) => {
    setSuppliers([...suppliers, { ...supplierData, id: Date.now() }]);
    setShowAddSupplier(false);
  };
  const updateSupplier = (updatedSupplier) => {
    setSuppliers(suppliers.map(s => s.id === updatedSupplier.id ? updatedSupplier : s));
    setEditingSupplier(null);
  };
  const deleteSupplier = (id) => {
    if (window.confirm('¿Está seguro de eliminar este proveedor?')) {
      setSuppliers(suppliers.filter(s => s.id !== id));
    }
  };

  // === Login Screen ===
  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Package className="text-white w-8 h-8" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Epack - Proyecto PacPac</h1>
            <p className="text-gray-600">Sistema de Gestión de Producción</p>
          </div>
          <div className="space-y-4">
            <input
              type="password"
              placeholder="Ingrese PIN de acceso"
              value={pinInput}
              onChange={(e) => setPinInput(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
            />
            <button
              onClick={handleLogin}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2"
            >
              <Lock className="w-5 h-5" />
              <span>Acceder al Sistema</span>
            </button>
            <div className="text-center text-sm text-gray-500 mt-4">
              <p>PIN de acceso: <code className="bg-gray-100 px-2 py-1 rounded">123qwe</code></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // === Vista Principal (Epack) ===
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <Package className="text-white w-6 h-6" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Epack - Proyecto Pac Pac</h1>
                <p className="text-sm text-gray-500">Control Total</p>
              </div>
            </div>
            <button onClick={logout} className="flex items-center space-x-1 text-red-600 hover:text-red-800">
              <LogOut className="w-4 h-4" />
              <span>Salir</span>
            </button>
          </div>
        </div>
      </header>
      <nav className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8 overflow-x-auto">
            {[
              { id: 'dashboard', label: 'Dashboard', icon: Home },
              { id: 'gantt', label: 'Gantt & Avance', icon: CalendarDays },
              { id: 'avances', label: 'Registro de Avances', icon: ClipboardList },
              { id: 'proveedores', label: 'Proveedores', icon: Building },
              { id: 'entregas', label: 'Entregas', icon: Truck },
              { id: 'finanzas', label: 'Finanzas', icon: DollarSign },
              { id: 'insumos', label: 'Insumos', icon: Package }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <tab.icon className="w-4 h-4" />
                <span>{tab.label}</span>
              </button>
            ))}
            <button
              onClick={() => setActiveTab('configuracion')}
              className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
                activeTab === 'configuracion'
                  ? 'border-purple-500 text-purple-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Cog className="w-4 h-4" />
              <span>Configuración</span>
            </button>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'dashboard' && (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Bolsas Asignadas</p>
                    <p className="text-3xl font-bold text-gray-900">{assignedBags.toLocaleString()}</p>
                  </div>
                  <Package className="text-blue-500 w-8 h-8" />
                </div>
                <button
                  onClick={() => setShowEditTotalBags(true)}
                  className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center"
                >
                  <Edit3 className="w-3 h-3 mr-1" />
                  Editar
                </button>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Completado</p>
                    <p className="text-3xl font-bold text-green-600">{totalProgress.toLocaleString()}</p>
                  </div>
                  <CheckCircle className="text-green-500 w-8 h-8" />
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Restante</p>
                    <p className="text-3xl font-bold text-red-600">{(assignedBags - totalProgress).toLocaleString()}</p>
                  </div>
                  <AlertCircle className="text-red-500 w-8 h-8" />
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Progreso Diario</p>
                    <p className="text-3xl font-bold text-yellow-600">{dailyProgress.toLocaleString()}</p>
                  </div>
                  <Clock className="text-yellow-500 w-8 h-8" />
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Progreso General - Separado por Procesos</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h4 className="text-md font-medium text-gray-700 mb-2">Troquelado y Corte</h4>
                  <div className="mb-4">
                    <div className="flex justify-between text-sm text-gray-600 mb-1">
                      <span>Completado: {troqueladoProgress.toLocaleString()}</span>
                      <span>Faltante: {(assignedBags - troqueladoProgress).toLocaleString()}</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-blue-600 h-2 rounded-full"
                        style={{ width: `${(troqueladoProgress / assignedBags) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                  <div className="h-48">
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={[
                            { name: 'Completado', value: troqueladoProgress, color: '#3b82f6' },
                            { name: 'Restante', value: assignedBags - troqueladoProgress, color: '#94a3b8' }
                          ]}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={60}
                          fill="#8884d8"
                          dataKey="value"
                          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        >
                          <Cell fill="#3b82f6" />
                          <Cell fill="#94a3b8" />
                        </Pie>
                        <Tooltip formatter={(value) => [value.toLocaleString(), 'Bolsas']} />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div>
                  <h4 className="text-md font-medium text-gray-700 mb-2">Pegado de Asa</h4>
                  <div className="mb-4">
                    <div className="flex justify-between text-sm text-gray-600 mb-1">
                      <span>Completado: {pegadoProgress.toLocaleString()}</span>
                      <span>Faltante: {(assignedBags - pegadoProgress).toLocaleString()}</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-green-600 h-2 rounded-full"
                        style={{ width: `${(pegadoProgress / assignedBags) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                  <div className="h-48">
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={[
                            { name: 'Completado', value: pegadoProgress, color: '#10b981' },
                            { name: 'Restante', value: assignedBags - pegadoProgress, color: '#94a3b8' }
                          ]}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={60}
                          fill="#8884d8"
                          dataKey="value"
                          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        >
                          <Cell fill="#10b981" />
                          <Cell fill="#94a3b8" />
                        </Pie>
                        <Tooltip formatter={(value) => [value.toLocaleString(), 'Bolsas']} />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Comparativo de Productividad por Proveedor</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Avanzado</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Días Trabajados</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Productividad Diaria</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Capacidad/Día</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {proveedorProductividad.map((proveedor, index) => (
                      <tr key={proveedor.id} className={index < 3 ? 'bg-yellow-50' : ''}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {proveedor.name} - {proveedor.contact}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            proveedor.type === 'troquelado' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                          }`}>
                            {proveedor.type === 'troquelado' ? 'Troquelado' : 'Pegado'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {proveedor.totalAvanzado.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {proveedor.diasTrabajados}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-bold">
                          {proveedor.productividadDiaria.toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {proveedor.capacity.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Actividad Reciente</h3>
              <div className="space-y-4">
                {visits.slice(-3).reverse().map(visit => {
                  const supplier = suppliers.find(s => s.id === visit.supplierId);
                  return (
                    <div key={visit.id} className="flex items-start space-x-4 p-3 bg-gray-50 rounded-lg">
                      <div className={`w-3 h-3 rounded-full mt-2 ${
                        visit.type === 'troquelado' ? 'bg-blue-500' : 'bg-green-500'
                      }`}></div>
                      <div className="flex-1">
                        <p className="font-medium text-gray-900">
                          Visita a {supplier?.name} ({supplier?.contact})
                        </p>
                        <p className="text-sm text-gray-600">
                          {visit.quantity.toLocaleString()} bolsas - {new Date(visit.timestamp).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* Aquí van los demás módulos: gantt, avances, proveedores, entregas, finanzas, insumos, configuración */}
        {/* (El código de estos módulos es idéntico al de tu archivo original) */}

        {activeTab === 'gantt' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Gantt & Avance Interactivo</h2>
              <p className="text-gray-600 mb-6">Flujo de producción con seguimiento en tiempo real - Actualizado según entregas registradas</p>
              <div className="h-96 overflow-x-auto">
                <div id="gantt-chart" className="min-w-full">
                  <div className="space-y-3">
                    {ganttTasks.map(task => (
                      <div key={task.id} className="flex items-center space-x-3 p-3 border rounded-lg hover:shadow-md transition-shadow">
                        <div className="w-48 text-sm font-medium text-gray-800">{task.name}</div>
                        <div className="flex-1 bg-gray-200 rounded-full h-8">
                          <div 
                            className={`h-8 rounded-full transition-all duration-500 ${
                              task.custom_class === 'material-base' ? 'bg-blue-500' :
                              task.custom_class === 'troquelado' ? 'bg-purple-500' :
                              task.custom_class === 'pegado' ? 'bg-green-500' :
                              'bg-yellow-500'
                            }`}
                            style={{ width: `${task.progress}%` }}
                          ></div>
                        </div>
                        <div className="w-16 text-sm font-bold text-gray-700">{Math.round(task.progress)}%</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="bg-blue-50 p-3 rounded-lg">
                  <div className="text-xs text-blue-600 font-medium">Material Base</div>
                  <div className="text-lg font-bold text-blue-800">
                    {deliveries.find(d => d.stage === 'material_base')?.bags?.toLocaleString() || '0'}
                  </div>
                  <div className="text-xs text-blue-500">
                    Asas: {deliveries.find(d => d.stage === 'material_base')?.handles?.toLocaleString() || '0'}
                  </div>
                </div>
                <div className="bg-purple-50 p-3 rounded-lg">
                  <div className="text-xs text-purple-600 font-medium">Troquelado</div>
                  <div className="text-lg font-bold text-purple-800">{troqueladoProgress.toLocaleString()}</div>
                </div>
                <div className="bg-green-50 p-3 rounded-lg">
                  <div className="text-xs text-green-600 font-medium">Pegado</div>
                  <div className="text-lg font-bold text-green-800">{pegadoProgress.toLocaleString()}</div>
                </div>
                <div className="bg-yellow-50 p-3 rounded-lg">
                  <div className="text-xs text-yellow-600 font-medium">Entrega Final</div>
                  <div className="text-lg font-bold text-yellow-800">
                    {deliveries.filter(d => d.stage === 'entrega_final').reduce((sum, d) => sum + d.bags, 0).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Flujo de Materiales</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                    <Package className="text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-blue-800">PacPac → Epack</p>
                    <p className="text-sm text-blue-600">
                      Bolsas: {deliveries.find(d => d.stage === 'material_base')?.bags?.toLocaleString() || '0'} | 
                      Asas: {deliveries.find(d => d.stage === 'material_base')?.handles?.toLocaleString() || '0'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4 p-3 bg-purple-50 rounded-lg">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center">
                    <Truck className="text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-purple-800">Epack → Proveedores (Troquelado)</p>
                    <p className="text-sm text-purple-600">
                      {deliveries.filter(d => d.stage === 'troquelado_asignado').reduce((sum, d) => sum + d.bags, 0).toLocaleString()} bolsas asignadas
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                    <Truck className="text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-green-800">Troquelado → Pegado</p>
                    <p className="text-sm text-green-600">
                      {deliveries.filter(d => d.stage === 'pegado_asignado').reduce((sum, d) => sum + d.bags, 0).toLocaleString()} bolsas transferidas
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4 p-3 bg-yellow-50 rounded-lg">
                  <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                    <CheckCircle className="text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="font-medium text-yellow-800">Pegado → PacPac (Entrega Final)</p>
                    <p className="text-sm text-yellow-600">
                      {deliveries.filter(d => d.stage === 'entrega_final').reduce((sum, d) => sum + d.bags, 0).toLocaleString()} bolsas entregadas
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'avances' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Registrar Nuevo Avance</h2>
              <form onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                addVisit({
                  supplierId: parseInt(formData.get('supplierId')),
                  type: formData.get('type'),
                  quantity: parseInt(formData.get('quantity')),
                  supervisor: formData.get('supervisor'),
                  notes: formData.get('notes'),
                  stage: formData.get('type')
                });
                e.target.reset();
                alert('Avance registrado correctamente');
              }} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor</label>
                  <select name="supplierId" required className="w-full p-2 border rounded-lg">
                    {suppliers.map(supplier => (
                      <option key={supplier.id} value={supplier.id}>
                        {supplier.name} - {supplier.contact} ({supplier.type})
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
                  <select name="type" required className="w-full p-2 border rounded-lg">
                    <option value="troquelado">Troquelado</option>
                    <option value="pegado">Pegado de Asa</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cantidad</label>
                  <input type="number" name="quantity" required min="1" className="w-full p-2 border rounded-lg" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Supervisor</label>
                  <input type="text" name="supervisor" required className="w-full p-2 border rounded-lg" defaultValue="Carlos Mendoza" />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Notas</label>
                  <textarea name="notes" className="w-full p-2 border rounded-lg" rows="3"></textarea>
                </div>
                <div className="md:col-span-2">
                  <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                    Registrar Avance
                  </button>
                </div>
              </form>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Avances por Proveedor</h3>
                <div className="h-64">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={proveedorProductividad.slice(0, 5)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                      <YAxis />
                      <Tooltip formatter={(value) => [value.toLocaleString(), 'Bolsas']} />
                      <Bar dataKey="totalAvanzado" fill="#8884d8" name="Bolsas Avanzadas" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Avances por Día</h3>
                <div className="h-64">
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={visits.slice(-7).map(v => ({
                      fecha: new Date(v.timestamp).toLocaleDateString(),
                      cantidad: v.quantity
                    }))}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="fecha" />
                      <YAxis />
                      <Tooltip formatter={(value) => [value.toLocaleString(), 'Bolsas']} />
                      <Area type="monotone" dataKey="cantidad" stroke="#8884d8" fill="#8884d8" fillOpacity={0.3} />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Historial de Avances</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha y Hora</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Supervisor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notas</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {visits.map(visit => {
                      const supplier = suppliers.find(s => s.id === visit.supplierId);
                      return (
                        <tr key={visit.id}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {new Date(visit.timestamp).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {supplier?.name} - {supplier?.contact}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              visit.type === 'troquelado' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                            }`}>
                              {visit.type === 'troquelado' ? 'Troquelado' : 'Pegado'}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {visit.quantity.toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {visit.supervisor}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            {visit.notes || 'Sin notas'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-2">
                              <button
                                onClick={() => setEditingVisit(visit)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <Edit3 className="w-4 h-4" />
                              </button>
                              <button
                                onClick={() => deleteVisit(visit.id)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'proveedores' && (
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-bold text-gray-900">Proveedores</h2>
              <button
                onClick={() => setShowAddSupplier(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2"
              >
                <Plus className="w-4 h-4" />
                <span>Agregar Proveedor</span>
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {suppliers.map(supplier => (
                <div key={supplier.id} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="font-semibold text-gray-900">{supplier.name}</h3>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => setEditingSupplier(supplier)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <Edit3 className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => deleteSupplier(supplier.id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        supplier.type === 'troquelado' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                      }`}>
                        {supplier.type === 'troquelado' ? 'Troquelado' : 'Pegado'}
                      </span>
                    </div>
                  </div>
                  <div className="space-y-2 text-sm text-gray-600">
                    <div className="flex items-center space-x-2">
                      <Users className="w-4 h-4" />
                      <span>{supplier.contact}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Phone className="w-4 h-4" />
                      <span>{supplier.phone}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <MapPin className="w-4 h-4" />
                      <span>{supplier.location} - {supplier.stand}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Package className="w-4 h-4" />
                      <span>Capacidad: {supplier.capacity.toLocaleString()}/día</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <DollarSign className="w-4 h-4" />
                      <span>Tarifa: S/. {supplier.ratePerThousand}/millar</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <CreditCard className="w-4 h-4" />
                      <span>
                        Métodos: {supplier.paymentMethods.map(m => 
                          m === 'yape' ? 'Yape' :
                          m === 'plin' ? 'Plin' :
                          m === 'transferencia' ? 'Transferencia' : 'Efectivo'
                        ).join(', ')}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'entregas' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Registrar Entrega/Recolección</h2>
              <div className="mb-4 bg-blue-50 p-3 rounded-lg">
                <p className="text-sm text-blue-700 font-medium">Flujo de Entregas:</p>
                <ol className="text-xs text-blue-600 mt-1 space-y-1">
                  <li>1. PacPac entrega material base (bolsas y asas) a Epack</li>
                  <li>2. Epack asigna material a proveedores para troquelado</li>
                  <li>3. Proveedores de troquelado entregan a proveedores de pegado</li>
                  <li>4. Proveedores de pegado entregan a PacPac (entrega final)</li>
                </ol>
              </div>
              <form onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                const deliveryType = formData.get('deliveryType');
                let deliveryData = { type: deliveryType };
                switch(deliveryType) {
                  case 'pacpac_to_epack':
                    deliveryData = {
                      ...deliveryData,
                      from: 'PacPac',
                      to: 'Epack',
                      bags: parseInt(formData.get('bags')),
                      handles: parseInt(formData.get('handles')),
                      deliveredBy: formData.get('deliveredBy'),
                      receivedBy: formData.get('receivedBy'),
                      notes: formData.get('notes'),
                      stage: 'material_base'
                    };
                    break;
                  case 'epack_to_supplier':
                    deliveryData = {
                      ...deliveryData,
                      from: 'Epack',
                      to: suppliers.find(s => s.id === parseInt(formData.get('supplierId')))?.name || '',
                      supplierId: parseInt(formData.get('supplierId')),
                      bags: parseInt(formData.get('bags')),
                      handles: parseInt(formData.get('handles')),
                      deliveredBy: formData.get('deliveredBy'),
                      receivedBy: formData.get('receivedBy'),
                      notes: formData.get('notes'),
                      stage: 'troquelado_asignado'
                    };
                    break;
                  case 'supplier_to_supplier':
                    deliveryData = {
                      ...deliveryData,
                      from: suppliers.find(s => s.id === parseInt(formData.get('supplierFromId')))?.name || '',
                      to: suppliers.find(s => s.id === parseInt(formData.get('supplierToId')))?.name || '',
                      supplierFromId: parseInt(formData.get('supplierFromId')),
                      supplierToId: parseInt(formData.get('supplierToId')),
                      bags: parseInt(formData.get('bags')),
                      handles: parseInt(formData.get('handles')),
                      deliveredBy: formData.get('deliveredBy'),
                      receivedBy: formData.get('receivedBy'),
                      notes: formData.get('notes'),
                      stage: 'pegado_asignado'
                    };
                    break;
                  case 'supplier_to_pacpac':
                    deliveryData = {
                      ...deliveryData,
                      from: suppliers.find(s => s.id === parseInt(formData.get('supplierId')))?.name || '',
                      to: 'PacPac',
                      supplierId: parseInt(formData.get('supplierId')),
                      bags: parseInt(formData.get('bags')),
                      handles: parseInt(formData.get('handles')),
                      deliveredBy: formData.get('deliveredBy'),
                      receivedBy: formData.get('receivedBy'),
                      notes: formData.get('notes'),
                      stage: 'entrega_final'
                    };
                    break;
                }
                addDelivery(deliveryData);
                e.target.reset();
                alert('Entrega registrada correctamente');
              }} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Entrega</label>
                  <select name="deliveryType" required className="w-full p-2 border rounded-lg" id="deliveryType">
                    <option value="pacpac_to_epack">PacPac → Epack (Material Base)</option>
                    <option value="epack_to_supplier">Epack → Proveedor (Troquelado)</option>
                    <option value="supplier_to_supplier">Proveedor → Proveedor (Troquelado → Pegado)</option>
                    <option value="supplier_to_pacpac">Proveedor → PacPac (Entrega Final)</option>
                  </select>
                </div>
                <div id="dynamicFields">
                  <div id="pacpac_to_epack_fields">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Bolsas</label>
                        <input type="number" name="bags" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Asas</label>
                        <input type="number" name="handles" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                    </div>
                  </div>
                  <div id="epack_to_supplier_fields" className="hidden">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor (Troquelado)</label>
                        <select name="supplierId" required className="w-full p-2 border rounded-lg">
                          {suppliers.filter(s => s.type === 'troquelado').map(supplier => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name} - {supplier.contact}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Bolsas</label>
                        <input type="number" name="bags" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Asas</label>
                        <input type="number" name="handles" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                    </div>
                  </div>
                  <div id="supplier_to_supplier_fields" className="hidden">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor Origen (Troquelado)</label>
                        <select name="supplierFromId" required className="w-full p-2 border rounded-lg">
                          {suppliers.filter(s => s.type === 'troquelado').map(supplier => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name} - {supplier.contact}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor Destino (Pegado)</label>
                        <select name="supplierToId" required className="w-full p-2 border rounded-lg">
                          {suppliers.filter(s => s.type === 'pegado').map(supplier => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name} - {supplier.contact}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Bolsas</label>
                        <input type="number" name="bags" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Asas</label>
                        <input type="number" name="handles" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                    </div>
                  </div>
                  <div id="supplier_to_pacpac_fields" className="hidden">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor (Pegado)</label>
                        <select name="supplierId" required className="w-full p-2 border rounded-lg">
                          {suppliers.filter(s => s.type === 'pegado').map(supplier => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name} - {supplier.contact}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Bolsas</label>
                        <input type="number" name="bags" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Asas</label>
                        <input type="number" name="handles" required min="0" className="w-full p-2 border rounded-lg" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Entregado por</label>
                    <input type="text" name="deliveredBy" required className="w-full p-2 border rounded-lg" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Recibido por</label>
                    <input type="text" name="receivedBy" required className="w-full p-2 border rounded-lg" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Notas</label>
                  <textarea name="notes" className="w-full p-2 border rounded-lg" rows="3"></textarea>
                </div>
                <button type="submit" className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors w-full">
                  Registrar Entrega
                </button>
              </form>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Historial de Entregas</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha y Hora</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">De</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">A</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bolsas</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Asas</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entregado por</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Recibido por</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {deliveries.map(delivery => {
                      return (
                        <tr key={delivery.id}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {new Date(delivery.timestamp).toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              delivery.stage === 'material_base' ? 'bg-blue-100 text-blue-800' :
                              delivery.stage === 'troquelado_asignado' ? 'bg-purple-100 text-purple-800' :
                              delivery.stage === 'pegado_asignado' ? 'bg-green-100 text-green-800' :
                              'bg-yellow-100 text-yellow-800'
                            }`}>
                              {delivery.stage === 'material_base' ? 'Material Base' :
                               delivery.stage === 'troquelado_asignado' ? 'Troquelado' :
                               delivery.stage === 'pegado_asignado' ? 'Pegado' : 'Entrega Final'}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {delivery.from}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {delivery.to}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {delivery.bags.toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {delivery.handles.toLocaleString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {delivery.deliveredBy}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {delivery.receivedBy}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-2">
                              <button
                                onClick={() => setEditingDelivery(delivery)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <Edit3 className="w-4 h-4" />
                              </button>
                              <button
                                onClick={() => deleteDelivery(delivery.id)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'finanzas' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-green-100 rounded-xl p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-green-800">Monto Depositado por Cliente</p>
                    <p className="text-2xl font-bold text-green-900">S/. {totalIncomes.toLocaleString()}</p>
                  </div>
                  <DollarSign className="text-green-600 w-8 h-8" />
                </div>
              </div>
              <div className="bg-red-100 rounded-xl p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-red-800">Pagos a Proveedores</p>
                    <p className="text-2xl font-bold text-red-900">S/. {costoTotal.toLocaleString()}</p>
                  </div>
                  <TrendingDown className="text-red-600 w-8 h-8" />
                </div>
              </div>
              <div className="bg-purple-100 rounded-xl p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-purple-800">Utilidad Estimada</p>
                    <p className="text-2xl font-bold text-purple-900">S/. {utilidadProyectada.toLocaleString()}</p>
                  </div>
                  <Activity className="text-purple-600 w-8 h-8" />
                </div>
              </div>
              <div className="bg-yellow-100 rounded-xl p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-yellow-800">Saldo en Caja</p>
                    <p className="text-2xl font-bold text-yellow-900">S/. {cashBalance.toLocaleString()}</p>
                  </div>
                  <Wallet className="text-yellow-600 w-8 h-8" />
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-6">Configuración Financiera Detallada</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">Bolsas Asignadas por PacPac</h3>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Cantidad de Bolsas</label>
                    <input
                      type="number"
                      value={assignedBags}
                      onChange={(e) => setAssignedBags(parseInt(e.target.value))}
                      className="w-full p-2 border rounded-lg"
                    />
                  </div>
                </div>
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">Precios de Venta a PacPac</h3>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Troquelado y Corte (S/.)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={ventaTroquelado}
                      onChange={(e) => setVentaTroquelado(parseFloat(e.target.value))}
                      className="w-full p-2 border rounded-lg"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Armado de Asa (S/.)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={ventaPegado}
                      onChange={(e) => setVentaPegado(parseFloat(e.target.value))}
                      className="w-full p-2 border rounded-lg"
                    />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">Precios Proveedores - Troquelado y Corte</h3>
                  {suppliers.filter(s => s.type === 'troquelado').map(supplier => (
                    <div key={supplier.id} className="flex items-center space-x-2">
                      <span className="text-sm font-medium text-gray-700 flex-1">
                        {supplier.name} - {supplier.contact}
                      </span>
                      <input
                        type="number"
                        step="0.01"
                        value={costoTroqueladoProveedores[supplier.id] || supplier.ratePerThousand}
                        onChange={(e) => setCostoTroqueladoProveedores({
                          ...costoTroqueladoProveedores,
                          [supplier.id]: parseFloat(e.target.value)
                        })}
                        className="w-24 p-1 border rounded text-sm"
                      />
                    </div>
                  ))}
                </div>
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">Precios Proveedores - Armado de Asa</h3>
                  {suppliers.filter(s => s.type === 'pegado').map(supplier => (
                    <div key={supplier.id} className="flex items-center space-x-2">
                      <span className="text-sm font-medium text-gray-700 flex-1">
                        {supplier.name} - {supplier.contact}
                      </span>
                      <input
                        type="number"
                        step="0.01"
                        value={costoPegadoProveedores[supplier.id] || supplier.ratePerThousand}
                        onChange={(e) => setCostoPegadoProveedores({
                          ...costoPegadoProveedores,
                          [supplier.id]: parseFloat(e.target.value)
                        })}
                        className="w-24 p-1 border rounded text-sm"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold text-gray-900">Registro de Ingresos</h2>
                  <button
                    onClick={() => setEditingIncome({})}
                    className="bg-green-600 text-white px-3 py-1 rounded-lg text-sm flex items-center space-x-1"
                  >
                    <Plus className="w-3 h-3" />
                    <span>Nuevo</span>
                  </button>
                </div>
                {editingIncome && (
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    const formData = new FormData(e.target);
                    const incomeData = {
                      id: editingIncome.id || Date.now(),
                      amount: parseFloat(formData.get('amount')),
                      concept: formData.get('concept'),
                      type: formData.get('type'),
                      paymentMethod: formData.get('paymentMethod'),
                      timestamp: editingIncome.id ? editingIncome.timestamp : new Date().toISOString()
                    };
                    if (editingIncome.id) {
                      updateIncome(incomeData);
                    } else {
                      addIncome(incomeData);
                    }
                  }} className="space-y-3 mb-4 p-3 bg-gray-50 rounded-lg">
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Monto (S/.)</label>
                        <input
                          type="number"
                          step="0.01"
                          name="amount"
                          defaultValue={editingIncome.amount || ''}
                          required
                          className="w-full p-2 border rounded text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Tipo</label>
                        <select
                          name="type"
                          defaultValue={editingIncome.type || 'adelanto'}
                          required
                          className="w-full p-2 border rounded text-sm"
                        >
                          <option value="adelanto">Adelanto</option>
                          <option value="pago">Pago Parcial</option>
                          <option value="final">Pago Final</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Método de Pago</label>
                      <select
                        name="paymentMethod"
                        defaultValue={editingIncome.paymentMethod || 'transferencia'}
                        required
                        className="w-full p-2 border rounded text-sm"
                      >
                        <option value="transferencia">Transferencia Bancaria</option>
                        <option value="yape">Yape</option>
                        <option value="plin">Plin</option>
                        <option value="efectivo">Efectivo</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Concepto</label>
                      <input
                        type="text"
                        name="concept"
                        defaultValue={editingIncome.concept || ''}
                        required
                        className="w-full p-2 border rounded text-sm"
                      />
                    </div>
                    <div className="flex justify-end space-x-2">
                      <button
                        type="button"
                        onClick={() => setEditingIncome(null)}
                        className="px-3 py-1 text-gray-600 text-sm"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                      >
                        {editingIncome.id ? 'Actualizar' : 'Guardar'}
                      </button>
                    </div>
                  </form>
                )}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Concepto</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Método</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {incomes.map(income => (
                        <tr key={income.id}>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {new Date(income.timestamp).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
                            {income.concept}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {income.type}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {income.paymentMethod === 'yape' ? 'Yape' :
                             income.paymentMethod === 'plin' ? 'Plin' :
                             income.paymentMethod === 'transferencia' ? 'Transferencia' : 'Efectivo'}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-green-600 font-medium">
                            +S/. {income.amount.toFixed(2)}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-1">
                              <button
                                onClick={() => setEditingIncome(income)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <Edit3 className="w-3 h-3" />
                              </button>
                              <button
                                onClick={() => deleteIncome(income.id)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <Trash2 className="w-3 h-3" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold text-gray-900">Registro de Gastos</h2>
                  <button
                    onClick={() => setEditingExpense({})}
                    className="bg-red-600 text-white px-3 py-1 rounded-lg text-sm flex items-center space-x-1"
                  >
                    <Plus className="w-3 h-3" />
                    <span>Nuevo</span>
                  </button>
                </div>
                {editingExpense && (
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    const formData = new FormData(e.target);
                    const expenseData = {
                      id: editingExpense.id || Date.now(),
                      amount: parseFloat(formData.get('amount')),
                      concept: formData.get('concept'),
                      category: formData.get('category'),
                      paymentMethod: formData.get('paymentMethod'),
                      timestamp: editingExpense.id ? editingExpense.timestamp : new Date().toISOString()
                    };
                    if (editingExpense.id) {
                      updateExpense(expenseData);
                    } else {
                      addExpense(expenseData);
                    }
                  }} className="space-y-3 mb-4 p-3 bg-gray-50 rounded-lg">
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Monto (S/.)</label>
                        <input
                          type="number"
                          step="0.01"
                          name="amount"
                          defaultValue={editingExpense.amount || ''}
                          required
                          className="w-full p-2 border rounded text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Categoría</label>
                        <select
                          name="category"
                          defaultValue={editingExpense.category || 'transporte'}
                          required
                          className="w-full p-2 border rounded text-sm"
                        >
                          <option value="transporte">Transporte</option>
                          <option value="materiales">Materiales</option>
                          <option value="servicios">Servicios</option>
                          <option value="otros">Otros</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Método de Pago</label>
                      <select
                        name="paymentMethod"
                        defaultValue={editingExpense.paymentMethod || 'efectivo'}
                        required
                        className="w-full p-2 border rounded text-sm"
                      >
                        <option value="efectivo">Efectivo</option>
                        <option value="yape">Yape</option>
                        <option value="plin">Plin</option>
                        <option value="transferencia">Transferencia Bancaria</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">Concepto</label>
                      <input
                        type="text"
                        name="concept"
                        defaultValue={editingExpense.concept || ''}
                        required
                        className="w-full p-2 border rounded text-sm"
                      />
                    </div>
                    <div className="flex justify-end space-x-2">
                      <button
                        type="button"
                        onClick={() => setEditingExpense(null)}
                        className="px-3 py-1 text-gray-600 text-sm"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="bg-red-600 text-white px-3 py-1 rounded text-sm"
                      >
                        {editingExpense.id ? 'Actualizar' : 'Guardar'}
                      </button>
                    </div>
                  </form>
                )}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Concepto</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoría</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Método</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {expenses.map(expense => (
                        <tr key={expense.id}>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {new Date(expense.timestamp).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
                            {expense.concept}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {expense.category}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {expense.paymentMethod === 'yape' ? 'Yape' :
                             expense.paymentMethod === 'plin' ? 'Plin' :
                             expense.paymentMethod === 'transferencia' ? 'Transferencia' : 'Efectivo'}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-red-600 font-medium">
                            -S/. {expense.amount.toFixed(2)}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-1">
                              <button
                                onClick={() => setEditingExpense(expense)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <Edit3 className="w-3 h-3" />
                              </button>
                              <button
                                onClick={() => deleteExpense(expense.id)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <Trash2 className="w-3 h-3" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-900">Pago a Proveedores</h2>
                <button
                  onClick={() => setShowAddSupplierPayment(true)}
                  className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm flex items-center space-x-1"
                >
                  <Plus className="w-3 h-3" />
                  <span>Nuevo Pago</span>
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Concepto</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Método</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {supplierPayments.map(payment => {
                      const supplier = suppliers.find(s => s.id === payment.supplierId);
                      return (
                        <tr key={payment.id}>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {new Date(payment.timestamp).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                            {supplier?.name}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {payment.concept}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            {payment.paymentMethod === 'yape' ? 'Yape' :
                             payment.paymentMethod === 'plin' ? 'Plin' :
                             payment.paymentMethod === 'transferencia' ? 'Transferencia' : 'Efectivo'}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-blue-600 font-medium">
                            S/. {payment.amount.toFixed(2)}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              payment.status === 'pagado' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                            }`}>
                              {payment.status === 'pagado' ? 'Pagado' : 'Pendiente'}
                            </span>
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-1">
                              <button
                                onClick={() => setEditingSupplierPayment(payment)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <Edit3 className="w-3 h-3" />
                              </button>
                              <button
                                onClick={() => deleteSupplierPayment(payment.id)}
                                className="text-red-600 hover:text-red-800"
                              >
                                <Trash2 className="w-3 h-3" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Saldo Financiero por Período</h3>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setSelectedDateRange('dia')}
                    className={`px-3 py-1 rounded text-sm ${
                      selectedDateRange === 'dia' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    Día
                  </button>
                  <button
                    onClick={() => setSelectedDateRange('semana')}
                    className={`px-3 py-1 rounded text-sm ${
                      selectedDateRange === 'semana' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    Semana
                  </button>
                  <button
                    onClick={() => setSelectedDateRange('mes')}
                    className={`px-3 py-1 rounded text-sm ${
                      selectedDateRange === 'mes' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    Mes
                  </button>
                </div>
              </div>
              <div className="h-64">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={financialData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip formatter={(value) => [`S/. ${value.toLocaleString()}`, 'Monto']} />
                    <Bar dataKey="ingresos" fill="#10b981" name="Ingresos" />
                    <Bar dataKey="gastos" fill="#ef4444" name="Gastos" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'insumos' && (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Registrar Insumo</h2>
              <form onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                const supply = {
                  name: formData.get('name'),
                  quantity: parseInt(formData.get('quantity')),
                  unit: formData.get('unit'),
                  cost: parseFloat(formData.get('cost')),
                  supplier: formData.get('supplier')
                };
                setSupplies([...supplies, { ...supply, id: Date.now(), timestamp: new Date().toISOString() }]);
                e.target.reset();
                alert('Insumo registrado correctamente');
              }} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nombre del Insumo</label>
                  <input type="text" name="name" required className="w-full p-2 border rounded-lg" placeholder="Goma, troqueles, sacabocados, etc." />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cantidad</label>
                  <input type="number" name="quantity" required min="1" className="w-full p-2 border rounded-lg" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Unidad</label>
                  <input type="text" name="unit" required className="w-full p-2 border rounded-lg" placeholder="kg, unidades, rollos, etc." />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Costo (S/.)</label>
                  <input type="number" step="0.01" name="cost" required min="0.01" className="w-full p-2 border rounded-lg" />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Proveedor</label>
                  <input type="text" name="supplier" required className="w-full p-2 border rounded-lg" />
                </div>
                <div className="md:col-span-2">
                  <button type="submit" className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-colors">
                    Registrar Insumo
                  </button>
                </div>
              </form>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Inventario de Insumos</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Insumo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Costo Total</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {supplies.map(supply => (
                      <tr key={supply.id}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{supply.name}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{supply.quantity} {supply.unit}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">S/. {supply.cost.toFixed(2)}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{supply.supplier}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(supply.timestamp).toLocaleDateString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'configuracion' && (
          <div className="bg-white rounded-xl shadow-sm p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-6">Configuración del Proyecto</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-gray-900">Cantidad Total de Bolsas</h3>
                <div className="flex items-center space-x-4">
                  <input
                    type="number"
                    value={totalBags}
                    onChange={(e) => setTotalBags(parseInt(e.target.value))}
                    className="w-full p-2 border rounded-lg"
                  />
                  <button
                    onClick={() => setShowEditTotalBags(false)}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <h4 className="font-medium text-blue-800 mb-2">Tokens de Acceso</h4>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-blue-700 mb-2">Token Estándar (Vista Estática)</label>
                  <div className="flex items-center space-x-2">
                    <code className="bg-white px-3 py-2 rounded border flex-1">pacpac_token_12345</code>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText('pacpac_token_12345');
                        alert('Token copiado al portapapeles');
                      }}
                      className="bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 flex items-center space-x-1"
                    >
                      <Share2 className="w-4 h-4" />
                      <span>Copiar</span>
                    </button>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-blue-700 mb-2">Token Sesión en Vivo (Actualización en Tiempo Real)</label>
                  <div className="flex items-center space-x-2">
                    <code className="bg-white px-3 py-2 rounded border flex-1">{sharedSessionToken}</code>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(sharedSessionToken);
                        alert('Token de sesión en vivo copiado al portapapeles');
                      }}
                      className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700 flex items-center space-x-1"
                    >
                      <Share2 className="w-4 h-4" />
                      <span>Copiar</span>
                    </button>
                  </div>
                  <p className="text-xs text-blue-600 mt-2">
                    Este token permite a tu cliente ver actualizaciones en tiempo real del progreso del proyecto.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>

      {/* Modales (IGUAL que tu archivo original) */}
      {editingVisit && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Editar Avance</h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              updateVisit({
                ...editingVisit,
                supplierId: parseInt(formData.get('supplierId')),
                type: formData.get('type'),
                quantity: parseInt(formData.get('quantity')),
                supervisor: formData.get('supervisor'),
                notes: formData.get('notes')
              });
            }} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor</label>
                <select name="supplierId" required className="w-full p-2 border rounded-lg">
                  {suppliers.map(supplier => (
                    <option key={supplier.id} value={supplier.id} selected={supplier.id === editingVisit.supplierId}>
                      {supplier.name} - {supplier.contact} ({supplier.type})
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                <select name="type" required className="w-full p-2 border rounded-lg">
                  <option value="troquelado" selected={editingVisit.type === 'troquelado'}>Troquelado</option>
                  <option value="pegado" selected={editingVisit.type === 'pegado'}>Pegado de Asa</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Cantidad</label>
                <input
                  type="number"
                  name="quantity"
                  defaultValue={editingVisit.quantity}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Supervisor</label>
                <input
                  type="text"
                  name="supervisor"
                  defaultValue={editingVisit.supervisor}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notas</label>
                <textarea
                  name="notes"
                  defaultValue={editingVisit.notes}
                  className="w-full p-2 border rounded-lg"
                  rows="3"
                ></textarea>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEditingVisit(null)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  Actualizar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editingDelivery && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Editar Entrega/Recolección</h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const deliveryType = editingDelivery.type;
              let deliveryData = { ...editingDelivery };
              switch(deliveryType) {
                case 'pacpac_to_epack':
                  deliveryData.bags = parseInt(formData.get('bags'));
                  deliveryData.handles = parseInt(formData.get('handles'));
                  deliveryData.deliveredBy = formData.get('deliveredBy');
                  deliveryData.receivedBy = formData.get('receivedBy');
                  deliveryData.notes = formData.get('notes');
                  break;
                case 'epack_to_supplier':
                  deliveryData.supplierId = parseInt(formData.get('supplierId'));
                  deliveryData.bags = parseInt(formData.get('bags'));
                  deliveryData.handles = parseInt(formData.get('handles'));
                  deliveryData.deliveredBy = formData.get('deliveredBy');
                  deliveryData.receivedBy = formData.get('receivedBy');
                  deliveryData.notes = formData.get('notes');
                  break;
                case 'supplier_to_supplier':
                  deliveryData.supplierFromId = parseInt(formData.get('supplierFromId'));
                  deliveryData.supplierToId = parseInt(formData.get('supplierToId'));
                  deliveryData.bags = parseInt(formData.get('bags'));
                  deliveryData.handles = parseInt(formData.get('handles'));
                  deliveryData.deliveredBy = formData.get('deliveredBy');
                  deliveryData.receivedBy = formData.get('receivedBy');
                  deliveryData.notes = formData.get('notes');
                  break;
                case 'supplier_to_pacpac':
                  deliveryData.supplierId = parseInt(formData.get('supplierId'));
                  deliveryData.bags = parseInt(formData.get('bags'));
                  deliveryData.handles = parseInt(formData.get('handles'));
                  deliveryData.deliveredBy = formData.get('deliveredBy');
                  deliveryData.receivedBy = formData.get('receivedBy');
                  deliveryData.notes = formData.get('notes');
                  break;
              }
              updateDelivery(deliveryData);
            }} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Entrega</label>
                <div className="p-2 bg-gray-100 rounded">
                  {editingDelivery.stage === 'material_base' ? 'PacPac → Epack (Material Base)' :
                   editingDelivery.stage === 'troquelado_asignado' ? 'Epack → Proveedor (Troquelado)' :
                   editingDelivery.stage === 'pegado_asignado' ? 'Proveedor → Proveedor (Troquelado → Pegado)' :
                   'Proveedor → PacPac (Entrega Final)'}
                </div>
              </div>
              {editingDelivery.stage === 'material_base' && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Bolsas</label>
                    <input
                      type="number"
                      name="bags"
                      defaultValue={editingDelivery.bags}
                      required
                      className="w-full p-2 border rounded-lg"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Asas</label>
                    <input
                      type="number"
                      name="handles"
                      defaultValue={editingDelivery.handles}
                      required
                      className="w-full p-2 border rounded-lg"
                    />
                  </div>
                </div>
              )}
              {editingDelivery.stage === 'troquelado_asignado' && (
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor (Troquelado)</label>
                    <select name="supplierId" required className="w-full p-2 border rounded-lg">
                      {suppliers.filter(s => s.type === 'troquelado').map(supplier => (
                        <option key={supplier.id} value={supplier.id} selected={supplier.id === editingDelivery.supplierId}>
                          {supplier.name} - {supplier.contact}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Bolsas</label>
                      <input
                        type="number"
                        name="bags"
                        defaultValue={editingDelivery.bags}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Asas</label>
                      <input
                        type="number"
                        name="handles"
                        defaultValue={editingDelivery.handles}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              )}
              {editingDelivery.stage === 'pegado_asignado' && (
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor Origen (Troquelado)</label>
                      <select name="supplierFromId" required className="w-full p-2 border rounded-lg">
                        {suppliers.filter(s => s.type === 'troquelado').map(supplier => (
                          <option key={supplier.id} value={supplier.id} selected={supplier.id === editingDelivery.supplierFromId}>
                            {supplier.name} - {supplier.contact}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor Destino (Pegado)</label>
                      <select name="supplierToId" required className="w-full p-2 border rounded-lg">
                        {suppliers.filter(s => s.type === 'pegado').map(supplier => (
                          <option key={supplier.id} value={supplier.id} selected={supplier.id === editingDelivery.supplierToId}>
                            {supplier.name} - {supplier.contact}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Bolsas</label>
                      <input
                        type="number"
                        name="bags"
                        defaultValue={editingDelivery.bags}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Asas</label>
                      <input
                        type="number"
                        name="handles"
                        defaultValue={editingDelivery.handles}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              )}
              {editingDelivery.stage === 'entrega_final' && (
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor (Pegado)</label>
                    <select name="supplierId" required className="w-full p-2 border rounded-lg">
                      {suppliers.filter(s => s.type === 'pegado').map(supplier => (
                        <option key={supplier.id} value={supplier.id} selected={supplier.id === editingDelivery.supplierId}>
                          {supplier.name} - {supplier.contact}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Bolsas</label>
                      <input
                        type="number"
                        name="bags"
                        defaultValue={editingDelivery.bags}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Asas</label>
                      <input
                        type="number"
                        name="handles"
                        defaultValue={editingDelivery.handles}
                        required
                        className="w-full p-2 border rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Entregado por</label>
                  <input
                    type="text"
                    name="deliveredBy"
                    defaultValue={editingDelivery.deliveredBy}
                    required
                    className="w-full p-2 border rounded-lg"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Recibido por</label>
                  <input
                    type="text"
                    name="receivedBy"
                    defaultValue={editingDelivery.receivedBy}
                    required
                    className="w-full p-2 border rounded-lg"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notas</label>
                <textarea
                  name="notes"
                  defaultValue={editingDelivery.notes}
                  className="w-full p-2 border rounded-lg"
                  rows="3"
                ></textarea>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEditingDelivery(null)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  Actualizar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {(showAddSupplier || editingSupplier) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              {editingSupplier ? 'Editar Proveedor' : 'Agregar Proveedor'}
            </h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const paymentMethods = [];
              if (formData.get('yape')) paymentMethods.push('yape');
              if (formData.get('plin')) paymentMethods.push('plin');
              if (formData.get('transferencia')) paymentMethods.push('transferencia');
              if (formData.get('efectivo')) paymentMethods.push('efectivo');
              const supplierData = {
                id: editingSupplier?.id || Date.now(),
                name: formData.get('name'),
                contact: formData.get('contact'),
                phone: formData.get('phone'),
                location: formData.get('location'),
                stand: formData.get('stand'),
                address: formData.get('address'),
                capacity: parseInt(formData.get('capacity')),
                type: formData.get('type'),
                ratePerThousand: parseFloat(formData.get('ratePerThousand')),
                paymentMethods: paymentMethods
              };
              if (editingSupplier) {
                updateSupplier(supplierData);
              } else {
                addSupplier(supplierData);
              }
            }} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                <input
                  type="text"
                  name="name"
                  defaultValue={editingSupplier?.name || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Contacto</label>
                <input
                  type="text"
                  name="contact"
                  defaultValue={editingSupplier?.contact || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                <input
                  type="text"
                  name="phone"
                  defaultValue={editingSupplier?.phone || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                  <select
                    name="type"
                    defaultValue={editingSupplier?.type || 'troquelado'}
                    required
                    className="w-full p-2 border rounded-lg"
                  >
                    <option value="troquelado">Troquelado</option>
                    <option value="pegado">Pegado de Asa</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Capacidad/Día</label>
                  <input
                    type="number"
                    name="capacity"
                    defaultValue={editingSupplier?.capacity || ''}
                    required
                    className="w-full p-2 border rounded-lg"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tarifa por Millar (S/.)</label>
                <input
                  type="number"
                  step="0.01"
                  name="ratePerThousand"
                  defaultValue={editingSupplier?.ratePerThousand || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ubicación</label>
                <input
                  type="text"
                  name="location"
                  defaultValue={editingSupplier?.location || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Stand/Local</label>
                <input
                  type="text"
                  name="stand"
                  defaultValue={editingSupplier?.stand || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
                <input
                  type="text"
                  name="address"
                  defaultValue={editingSupplier?.address || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Métodos de Pago</label>
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="yape"
                      defaultChecked={editingSupplier?.paymentMethods?.includes('yape')}
                      className="rounded"
                    />
                    <span>Yape</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="plin"
                      defaultChecked={editingSupplier?.paymentMethods?.includes('plin')}
                      className="rounded"
                    />
                    <span>Plin</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="transferencia"
                      defaultChecked={editingSupplier?.paymentMethods?.includes('transferencia')}
                      className="rounded"
                    />
                    <span>Transferencia Bancaria</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="efectivo"
                      defaultChecked={editingSupplier?.paymentMethods?.includes('efectivo')}
                      className="rounded"
                    />
                    <span>Efectivo</span>
                  </label>
                </div>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddSupplier(false);
                    setEditingSupplier(null);
                  }}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  {editingSupplier ? 'Actualizar' : 'Agregar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {(showAddSupplierPayment || editingSupplierPayment) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              {editingSupplierPayment ? 'Editar Pago a Proveedor' : 'Nuevo Pago a Proveedor'}
            </h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const paymentData = {
                id: editingSupplierPayment?.id || Date.now(),
                supplierId: parseInt(formData.get('supplierId')),
                amount: parseFloat(formData.get('amount')),
                concept: formData.get('concept'),
                paymentMethod: formData.get('paymentMethod'),
                status: formData.get('status'),
                timestamp: editingSupplierPayment?.timestamp || new Date().toISOString()
              };
              if (editingSupplierPayment) {
                updateSupplierPayment(paymentData);
              } else {
                addSupplierPayment(paymentData);
              }
            }} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Proveedor</label>
                <select name="supplierId" required className="w-full p-2 border rounded-lg">
                  {suppliers.map(supplier => (
                    <option key={supplier.id} value={supplier.id} selected={editingSupplierPayment?.supplierId === supplier.id}>
                      {supplier.name} - {supplier.contact}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Monto (S/.)</label>
                <input
                  type="number"
                  step="0.01"
                  name="amount"
                  defaultValue={editingSupplierPayment?.amount || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Concepto</label>
                <input
                  type="text"
                  name="concept"
                  defaultValue={editingSupplierPayment?.concept || ''}
                  required
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Método de Pago</label>
                <select name="paymentMethod" required className="w-full p-2 border rounded-lg">
                  <option value="efectivo" selected={editingSupplierPayment?.paymentMethod === 'efectivo'}>Efectivo</option>
                  <option value="yape" selected={editingSupplierPayment?.paymentMethod === 'yape'}>Yape</option>
                  <option value="plin" selected={editingSupplierPayment?.paymentMethod === 'plin'}>Plin</option>
                  <option value="transferencia" selected={editingSupplierPayment?.paymentMethod === 'transferencia'}>Transferencia Bancaria</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select name="status" required className="w-full p-2 border rounded-lg">
                  <option value="pagado" selected={editingSupplierPayment?.status === 'pagado'}>Pagado</option>
                  <option value="pendiente" selected={editingSupplierPayment?.status === 'pendiente'}>Pendiente</option>
                </select>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddSupplierPayment(false);
                    setEditingSupplierPayment(null);
                  }}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  {editingSupplierPayment ? 'Actualizar' : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditTotalBags && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Editar Cantidad Total de Bolsas</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cantidad Total</label>
                <input
                  type="number"
                  value={totalBags}
                  onChange={(e) => setTotalBags(parseInt(e.target.value))}
                  className="w-full p-2 border rounded-lg"
                />
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  onClick={() => setShowEditTotalBags(false)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800"
                >
                  Cancelar
                </button>
                <button
                  onClick={() => setShowEditTotalBags(false)}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

fetch("https://controluva.epack.pe/api/guardar_pedido.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    cliente: "Juan Pérez",
    cantidad: 1000,
    producto: "Bolsa de papel 24x35"
  })
})
  .then(res => res.json())
  .then(data => console.log(data));

export default App;